// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@nuxt/webpack/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".echarts[data-v-615b0d89]{width:100%;height:100%}.card[data-v-615b0d89]{border-top:3px solid #4d92e3}.card-body[data-v-615b0d89]{color:#4d92e3}.card-body h6[data-v-615b0d89]{font-weight:600}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
